import { ReturnsAndClaimsPermissions } from "@redotech/redo-model/permissions";
import { ReturnTypeEnum } from "@redotech/redo-model/return";
import { folderTypes } from "@redotech/redo-model/views/folders";
import { WarrantyView } from "@redotech/redo-model/views/views";
import { ReactNode, createContext, memo } from "react";
import { useViewsAndFolders } from "../hooks/use-views-and-folders";

export const WarrantyViewsContext = createContext<
  | {
      teamViews?: WarrantyView[];
      folders?: folderTypes["warranties"][];
      reloadViews?: () => Promise<void>;
    }
  | undefined
>(undefined);

export const ReloadWarrantyViewsContext = createContext<
  (() => Promise<void>) | undefined
>(undefined);

export const WarrantyViewsProvider = memo(function WarrantyViewsProvider({
  children,
}: {
  children: ReactNode | ReactNode[];
}) {
  const { views, folders, reloadViews } = useViewsAndFolders<
    WarrantyView,
    folderTypes["warranties"],
    ReturnTypeEnum.WARRANTY
  >(ReturnTypeEnum.WARRANTY, ReturnsAndClaimsPermissions.MANAGE_WARRANTY);

  return (
    <WarrantyViewsContext.Provider
      value={{ teamViews: views, folders, reloadViews }}
    >
      <ReloadWarrantyViewsContext.Provider value={reloadViews}>
        {children}
      </ReloadWarrantyViewsContext.Provider>
    </WarrantyViewsContext.Provider>
  );
});
